// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "a57a130be77ff719a9368eae9914fde4" + ".js";
};